/*@jsxRuntime automatic @jsxImportSource react*/
/*<!-- vale Google.Quotes = NO -->*/
/*<!-- vale Google.Quotes = YES -->*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import {Docs} from 'components/layout';
import {getIntegrations} from 'api/get-integrations';
import {getExtensions} from 'api/get-extensions';
import {Warning, Tip, Info, WhitelistDetails} from 'ui';
export const lastUpdatedDate = new Date(1683072000000);
export async function getStaticProps() {
  const integrations = await getIntegrations();
  const extensions = await getExtensions();
  return {
    props: {
      ...integrations,
      extensions,
      meta: {
        title: null,
        description: null,
        lastUpdatedDate: "Wed May 03 2023 00:00:00 GMT+0000 (Coordinated Universal Time)",
        slug: "airship",
        type: "destination",
        icon: null,
        toc: [{
          "value": "Supported syncing",
          "depth": 0,
          "id": "supported-syncing"
        }, {
          "value": "Connect to Airship",
          "depth": 0,
          "id": "connect-to-airship"
        }, {
          "value": "Sync configuration",
          "depth": 0,
          "id": "sync-configuration"
        }, {
          "value": "Syncing named users",
          "depth": 1,
          "id": "syncing-named-users"
        }, {
          "value": "Syncing subscription lists",
          "depth": 1,
          "id": "syncing-subscription-lists"
        }, {
          "value": "Tip and troubleshooting",
          "depth": 0,
          "id": "tip-and-troubleshooting"
        }, {
          "value": "Common errors",
          "depth": 1,
          "id": "common-errors"
        }, {
          "value": "Live debugger",
          "depth": 1,
          "id": "live-debugger"
        }, {
          "value": "Sync alerts",
          "depth": 1,
          "id": "sync-alerts"
        }]
      }
    },
    revalidate: 60
  };
}
const MDXLayout = ({children, ...props}) => _jsx(Docs, Object.assign({}, props, {
  children: children
}));
function MDXContent(props = {}) {
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, {})
  })) : _createMdxContent();
  function _createMdxContent() {
    const _components = Object.assign({
      h2: "h2",
      table: "table",
      thead: "thead",
      tr: "tr",
      th: "th",
      tbody: "tbody",
      td: "td",
      strong: "strong",
      a: "a",
      p: "p",
      ul: "ul",
      li: "li",
      h3: "h3",
      h4: "h4",
      em: "em",
      code: "code"
    }, _provideComponents(), props.components), {NoCommonErrors, LiveDebugger, SyncAlerts} = _components;
    if (!LiveDebugger) _missingMdxReference("LiveDebugger", true);
    if (!NoCommonErrors) _missingMdxReference("NoCommonErrors", true);
    if (!SyncAlerts) _missingMdxReference("SyncAlerts", true);
    return _jsxs(_Fragment, {
      children: [_jsx(_components.h2, {
        id: "supported-syncing",
        children: "Supported syncing"
      }), "\n", _jsxs(_components.table, {
        children: [_jsx(_components.thead, {
          children: _jsxs(_components.tr, {
            children: [_jsx(_components.th, {
              children: "Type"
            }), _jsx(_components.th, {
              children: "Description"
            }), _jsx(_components.th, {
              children: "Supported Sync Modes"
            }), _jsx(_components.th, {
              children: "API Reference"
            })]
          })
        }), _jsxs(_components.tbody, {
          children: [_jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: _jsx(_components.strong, {
                children: "Named users"
              })
            }), _jsx(_components.td, {
              children: "Sync tags and attributes to named users in Airship"
            }), _jsx(_components.td, {
              children: "Upsert, Update"
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "https://docs.airship.com/api/ua/?openapi=http#operation-api-named_users-named_user_id-post",
                children: "Named users docs"
              })
            })]
          }), _jsxs(_components.tr, {
            children: [_jsx(_components.td, {
              children: _jsx(_components.strong, {
                children: "Subscription lists"
              })
            }), _jsx(_components.td, {
              children: "Subscribe and unsubscribe named users from subscription lists"
            }), _jsx(_components.td, {
              children: "Add, Remove"
            }), _jsx(_components.td, {
              children: _jsx(_components.a, {
                href: "https://docs.airship.com/api/ua/?openapi=http#operation-api-named_users-scoped-named_user_id-post",
                children: "Subscription lists docs"
              })
            })]
          })]
        })]
      }), "\n", _jsxs(_components.p, {
        children: ["For more information about sync modes, refer to the ", _jsx(_components.a, {
          href: "/syncs/types-and-modes#sync-modes",
          children: "sync modes"
        }), " docs."]
      }), "\n", _jsx(_components.h2, {
        id: "connect-to-airship",
        children: "Connect to Airship"
      }), "\n", _jsxs(_components.p, {
        children: ["Go to the ", _jsxs(_components.a, {
          href: "https://app.hightouch.com/destinations",
          children: [_jsx(_components.strong, {
            children: "Destinations"
          }), " overview page"]
        }), " and click the ", _jsx(_components.strong, {
          children: "Add destination"
        }), " button. Select ", _jsx(_components.strong, {
          children: "Airship"
        }), " and click ", _jsx(_components.strong, {
          children: "Continue"
        }), ".\nYou can then authenticate Hightouch to Airship using either ", _jsx(_components.strong, {
          children: "basic authentication"
        }), " or ", _jsx(_components.strong, {
          children: "bearer authentication"
        }), "."]
      }), "\n", _jsxs(_components.p, {
        children: ["For both types, you need to enter your Airship ", _jsx(_components.strong, {
          children: "Cloud Site"
        }), ". See Airship's ", _jsx(_components.a, {
          href: "https://docs.airship.com/api/ua/?openapi=http#servers",
          children: "docs"
        }), " for more info."]
      }), "\n", _jsx(_components.p, {
        children: "Then, for basic authentication, enter these fields:"
      }), "\n", _jsxs(_components.ul, {
        children: ["\n", _jsxs(_components.li, {
          children: [_jsx(_components.strong, {
            children: "App Key"
          }), ": This is an Airship-generated string identifying your application. You can find it in your Airship dashboard."]
        }), "\n", _jsxs(_components.li, {
          children: [_jsx(_components.strong, {
            children: "Master Secret"
          }), ": Airship-generated string used for server-to-server API access. You can find it in your Airship dashboard."]
        }), "\n"]
      }), "\n", _jsxs(_components.p, {
        children: ["Follow the instructions in this ", _jsx(_components.a, {
          href: "https://support.airship.com/hc/en-us/articles/213491663-How-do-I-find-my-App-Key-App-Secret-or-Master-Secret-#:~:text=Open%20the%20app%20in%20the,right%20side%20of%20the%20screen.",
          children: "article"
        }), "\nto retrieve your ", _jsx(_components.strong, {
          children: "App Key"
        }), " and ", _jsx(_components.strong, {
          children: "Master Secret"
        })]
      }), "\n", _jsx(_components.p, {
        children: "For bearer authentication:"
      }), "\n", _jsxs(_components.ul, {
        children: ["\n", _jsxs(_components.li, {
          children: [_jsx(_components.strong, {
            children: "Access Token"
          }), ": This is an access token used to grant control permissions to the Airship API."]
        }), "\n"]
      }), "\n", _jsxs(_components.p, {
        children: ["Follow the instructions in this ", _jsx(_components.a, {
          href: "https://docs.airship.com/guides/messaging/user-guide/project/bearer-tokens/",
          children: "article"
        }), " to retrieve your ", _jsx(_components.strong, {
          children: "Access token"
        }), "."]
      }), "\n", _jsx(_components.h2, {
        id: "sync-configuration",
        children: "Sync configuration"
      }), "\n", _jsxs(_components.p, {
        children: ["Once you've set up your Airship destination and have a ", _jsx(_components.a, {
          href: "/getting-started/concepts#models",
          children: "model"
        }), " to pull data from, you can set up your sync configuration to begin syncing data. Go to the ", _jsxs(_components.a, {
          href: "https://app.hightouch.com/syncs",
          children: [_jsx(_components.strong, {
            children: "Syncs"
          }), " overview page"]
        }), " and click the ", _jsx(_components.strong, {
          children: "Add sync"
        }), " button to begin. Then, select the relevant model and the Airship destination you want to sync to."]
      }), "\n", _jsx(_components.h3, {
        id: "syncing-named-users",
        children: "Syncing named users"
      }), "\n", _jsxs(_components.p, {
        children: ["Sync tags and attributes to named users in Airship. Begin by selecting ", _jsx(_components.strong, {
          children: "Object"
        }), " as your sync type."]
      }), "\n", _jsx(_components.h4, {
        id: "record-matching",
        children: "Record matching"
      }), "\n", _jsxs(_components.p, {
        children: ["To match rows from your model to named users in Airship, you need to select the model column that contains values that match the ", _jsx(_components.strong, {
          children: "Named User ID"
        }), " field."]
      }), "\n", _jsx(_components.h4, {
        id: "field-mapping",
        children: "Field mapping"
      }), "\n", _jsx(_components.p, {
        children: "You can sync columns from your model to Airship attributes and tags."
      }), "\n", _jsxs(_components.p, {
        children: ["Hightouch provides a dropdown for ", _jsx(_components.a, {
          href: "https://docs.airship.com/guides/messaging/user-guide/audience/segmentation/attributes/reference/#default-attributes",
          children: "default attributes"
        }), " and ", _jsx(_components.a, {
          href: "https://docs.airship.com/guides/messaging/user-guide/audience/segmentation/attributes/reference/#predefined-attributes",
          children: "predefined attributes"
        }), ".\nIf you want to map custom attributes, you have to manually enter the ", _jsx(_components.a, {
          href: "https://docs.airship.com/guides/messaging/user-guide/audience/segmentation/attributes/about/#attribute-components-and-variations",
          children: "attribute ID"
        }), ", ", _jsx(_components.em, {
          children: "not attribute name"
        }), " in the mapper."]
      }), "\n", _jsx(Info, {
        children: _jsxs(_components.p, {
          children: ["Although ", _jsx(_components.a, {
            href: "https://docs.airship.com/guides/messaging/user-guide/audience/segmentation/attributes/reference/#predefined-attributes",
            children: "predefined\nattributes"
          }), "\nare avaliable in the dropdown by default, you must first define them in Airship\nfor them to be valid. Airship skips invalid attributes by default."]
        })
      }), "\n", _jsxs(_components.p, {
        children: ["Hightouch allows you to sync values to existing tag groups in Airship. Enter the ", _jsx(_components.strong, {
          children: "Group key"
        }), " in the right side of the tags mappings section to map values to an existing tag group.\nSee Airship's ", _jsx(_components.a, {
          href: "https://docs.airship.com/guides/messaging/user-guide/audience/segmentation/tags/#creating-custom-tag-groups",
          children: "docs"
        }), " for more information on tag groups."]
      }), "\n", "\n", _jsx(Tip, {
        children: _jsxs(_components.p, {
          children: ["You can map ", _jsx(_components.code, {
            children: "string"
          }), " or ", _jsx(_components.code, {
            children: "array"
          }), " values to tags.\nIf you provide a string, Hightouch automatically transforms it into an ", _jsx(_components.code, {
            children: "array"
          }), " using commas as the delimiters for different elements.\nFor example, Hightouch transforms the string ", _jsx(_components.code, {
            children: "\"dogs, cats, parrots\""
          }), " into this array: ", _jsx(_components.code, {
            children: "[\"dogs, \"cats\", \"parrots\"]"
          }), "."]
        })
      }), "\n", "\n", _jsx(_components.h3, {
        id: "syncing-subscription-lists",
        children: "Syncing subscription lists"
      }), "\n", _jsx(_components.p, {
        children: "Syncs can subscribe and unsubscribe named users from subscription lists."
      }), "\n", _jsx(_components.h4, {
        id: "record-matching-1",
        children: "Record matching"
      }), "\n", _jsxs(_components.p, {
        children: ["To match rows from your model to named users in Airship, you need to select the model column that contains values that match the ", _jsx(_components.strong, {
          children: "Named User ID"
        }), " field."]
      }), "\n", _jsx(_components.h4, {
        id: "field-mapping-1",
        children: "Field mapping"
      }), "\n", _jsxs(_components.p, {
        children: ["You can map data from any of your model columns to fields in Airship. Airship requires the ", _jsx(_components.strong, {
          children: "Scopes"
        }), " field, so you must map it to complete your configuration. Refer to Airship's ", _jsx(_components.a, {
          href: "https://docs.airship.com/api/ua/?openapi=http#schemas-scopes",
          children: "scopes docs"
        }), " to see valid values."]
      }), "\n", _jsx(_components.p, {
        children: "Ensure the data types of your model columns match the data types of the fields you want to sync to."
      }), "\n", _jsx(_components.h2, {
        id: "tip-and-troubleshooting",
        children: "Tip and troubleshooting"
      }), "\n", _jsx(_components.h3, {
        id: "common-errors",
        children: "Common errors"
      }), "\n", _jsx(NoCommonErrors, {}), "\n", _jsx(_components.h3, {
        id: "live-debugger",
        children: "Live debugger"
      }), "\n", _jsx(LiveDebugger, {}), "\n", _jsx(_components.h3, {
        id: "sync-alerts",
        children: "Sync alerts"
      }), "\n", _jsx(SyncAlerts, {})]
    });
  }
}
export default MDXContent;
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}
